import React from 'react';
import { FadeIn } from './FadeIn';
export function EmotionalHook() {
  return <section className="bg-white py-24 px-6" data-id="element-72">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row gap-12 items-center" data-id="element-73">
        <div className="w-full md:w-1/3 flex justify-center md:justify-end" data-id="element-74">
          <FadeIn data-id="element-75">
            <div className="relative w-48 h-48 sm:w-64 sm:h-64 rounded-full bg-crema flex items-center justify-center" data-id="element-76">
              <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-77">
                <circle cx="12" cy="12" r="10" data-id="element-78" />
                <polyline points="12 6 12 12 16 14" data-id="element-79" />
              </svg>
              <div className="absolute bottom-4 bg-white px-4 py-1 rounded-full shadow-sm text-azul-noche font-bold font-serif text-xl border border-crema" data-id="element-80">
                3:17 AM
              </div>
            </div>
          </FadeIn>
        </div>

        <div className="w-full md:w-2/3 space-y-6 text-lg text-texto" data-id="element-81">
          <FadeIn delay={0.1} data-id="element-82">
            <p className="font-serif text-2xl text-azul-noche font-bold" data-id="element-83">
              Son las 3am. De nuevo.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-84">
            <p data-id="element-85">
              No recuerdas la última vez que dormiste más de dos horas seguidas.
            </p>
            <p className="mt-4" data-id="element-86">
              No recuerdas la última vez que te despertaste sin que te
              despertaran.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-87">
            <p data-id="element-88">
              Tu cuerpo está haciendo cosas que los cuerpos hacen cuando están
              al límite — te duelen los músculos sin razón aparente, se te
              olvidan palabras en medio de las oraciones, lloras por cosas que
              en condiciones normales no te afectarían.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-89">
            <p className="font-medium" data-id="element-90">
              Pero lo más agotador no es el sueño perdido.
            </p>
            <p className="mt-4" data-id="element-91">
              Es la voz en tu cabeza que dice:{' '}
              <span className="italic" data-id="element-92">
                "¿por qué a mí? ¿Por qué mi bebé no duerme como los demás?"
              </span>
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-93">
            <p data-id="element-94">
              Y la respuesta que nadie te da — la respuesta real, no la del
              grupo de WhatsApp ni la de tu suegra — es esta:
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-95">
            <div className="pl-6 border-l-4 border-lila-suave py-2 my-6" data-id="element-96">
              <p className="font-bold text-xl text-azul-noche" data-id="element-97">
                Tu bebé no tiene ningún problema.
              </p>
              <p className="font-bold text-xl text-azul-noche mt-2" data-id="element-98">
                Tú no estás haciendo nada mal.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.7} data-id="element-99">
            <p data-id="element-100">
              Simplemente nadie te dio la información que necesitabas antes de
              que naciera tu bebé.
            </p>
            <p className="mt-4 font-medium text-azul-noche" data-id="element-101">
              Y eso — la información — es exactamente lo que está a punto de
              cambiar.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}